<template>
  <div class="LivePriceTicker">
    <div class="price-container">
      <div class="ticker-outer-section relative">
        <!-- <div class="market-type cursor-pointer" @click="openStockList()" v-if="$route.path != '/'">
          {{ selected_market_exchange }}

          <span><i class="el-icon-arrow-down" v-if="!is_market_list_open"></i></span>
          <span><i class="el-icon-arrow-up" v-if="is_market_list_open"></i></span>
        </div> -->

        <div id="container" class="marquee">
          <div class="marquee-content">
            <div class="right-margin-10 left-margin-10 relative" v-for="(stock, stock_index) in [...getStocksLivePricetList, ...getStocksLivePricetList, ...getStocksLivePricetList, ...getStocksLivePricetList]" :key="stock_index">
              <div :class="[stock_index < getStocksLivePricetList.length - 1 ? 'border-right' : '']" style="margin: 0 5px;">
                <span class="stock-name">{{ stock.name }}</span>

                <span class="stock-price">₹ {{ stock.current_price }}</span>

                <span class="percentage-change" :style="{ color: stock.price_potential > 0 ? '#00ca6f' : '#ff0037' }">
                  <i class="el-icon-top" v-if="stock.price_potential > 0"></i>
                  <i class="el-icon-bottom" v-else></i>
                  {{ stock.price_potential }} %
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="section-background" v-if="is_market_list_open" v-loading="is_market_list_loading" @click="closePriceTicker">
        <div class="stock-list-section">
          <div class="stock-list-container">
            <!-- menu links -->
            <div class="menu-links">
              <div class="menu" :class="[active_menu == 'Sectors' ? 'active-menu-link' : '']" @click="setActiveMenu('Sectors')">Sectors</div>

              <div class="menu" :class="[active_menu == 'Indices' ? 'active-menu-link' : '']" @click="setActiveMenu('Indices')">Indices</div>

              <div class="menu" :class="[active_menu == 'ETF' ? 'active-menu-link' : '']" @click="setActiveMenu('ETF')">ETF's</div>
            </div>

            <!-- market type -->
            <!-- <div class="top-margin-20 flex">
                            <div class="tag" :style="[ selected_market_exchange == 'NSE' ? { color: '#fff', borderColor: '#fff' } : {} ]" @click="setActiveMarketType('NSE')">NSE</div>

                            <div class="tag" :style="[ selected_market_exchange == 'BSE' ? { color: '#fff', borderColor: '#fff' } : {} ]" @click="setActiveMarketType('BSE')">BSE</div>
                        </div> -->

            <!-- market list -->
            <div class="top-margin-25">
              <el-row v-for="(market, market_index) in getMarketList" :key="market_index" :gutter="10">
                <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6" v-for="(sector, sector_index) in market.data" :key="sector_index" v-if="market.type == 'Sector' && active_menu == 'Sectors'">
                  <div class="list-items">
                    <span class="cursor-pointer" @click="goToMarketsPage(sector, 'Sector')">
                      {{ sector.value }}
                    </span>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6" v-for="(indices, index) in market.data" :key="index" v-if="market.type == 'Indices' && active_menu == 'Indices'">
                  <div class="list-items cursor-pointer">
                    <span class="cursor-pointer" @click="goToMarketsPage(indices, 'Indices')">
                      {{ indices.value }}
                    </span>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6" v-for="(etf, etf_index) in market.data" :key="etf_index" v-if="market.type == 'Etf' && active_menu == 'ETF'">
                  <div class="list-items cursor-pointer ellipsis" style="max-width: 250px">
                    <span class="cursor-pointer" @click="goToStockDetailsPage(etf, 'ETF')" :title="etf.value">
                      {{ etf.value }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';

export default {
  name: 'LivePriceTicker',

  data() {
    return {
      selected_market_exchange: 'BSE',
      is_market_list_open: false,

      active_menu: 'Sectors',

      is_market_list_loading: false,
      interval: null,
      scroll_time_interval: null,
    };
  },

  mounted() {
    if (!this.getMarketList.length) {
      this.getMarketListNetWorkCallBack();
    }

    if (!this.getStocksLivePricetList.length) {
      this.getStocksLivePriceNetWorkCallBack();
    }

    this.interval = setInterval(() => {
      // run for every 17 minutes to get live price
      this.getStocksLivePriceNetWorkCallBack();
    }, 17 * 60 * 1000);
  },

  methods: {
    // function called when sector and indices selected
    goToMarketsPage(market, type) {
      // if selected type == Sector then sent basket id as stock id

      this.is_market_list_open = false;

      let obj = {
        market: market.value,
        basket_id: market.id,
        stock_id: type == 'Sector' ? market.id : market.stock.id,
        type: type,
      };

      this.$store.commit('commitSelectedMarketType', obj);

      this.$router.push({ name: 'markets', params: { type: obj.type, label: obj.market, basket_id: obj.basket_id, stock_id: obj.stock_id } });

      // enable body scroll
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
    },

    closePriceTicker(e) {
      if (e.target.className == 'faded-background') {
        this.is_market_list_open = false;

        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'auto';
      }
    },

    // function called when ETF selected
    goToStockDetailsPage(stock, type) {
      this.is_market_list_open = false;

      let obj = {
        market: stock.value,
        stock_id: stock.id,
      };

      this.$store.commit('commitSelectedMarketType', obj);

      this.$router.push({ name: 'stockDetails', params: { type: 'Etf', label: obj.market, stock_id: obj.stock_id } });

      // enable body scroll
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
    },

    setBackground() {
      document.getElementById('section-background').setAttribute('class', 'faded-background');
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
    },

    disableBackground() {
      document.getElementById('section-background').removeAttribute('class');
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
    },

    openStockList() {
      if (this.is_market_list_open) {
        this.is_market_list_open = false;

        this.disableBackground(); //to hide black background
      } else {
        this.is_market_list_open = true;

        setTimeout(() => {
          this.setBackground(); //to set black background
        }, 20);
      }
      // this.is_market_list_open = !this.is_market_list_open;
    },

    setActiveMenu(menu) {
      if (menu == 'Sectors') {
        this.active_menu = 'Sectors';
      } else if (menu == 'Indices') {
        this.active_menu = 'Indices';
      } else if (menu == 'ETF') {
        this.active_menu = 'ETF';
      }
    },

    setActiveMarketType(type) {
      if (type == 'NSE') {
        this.selected_market_exchange = 'NSE';
      } else if (type == 'BSE') {
        this.selected_market_exchange = 'BSE';
      }

      this.getMarketListNetWorkCallBack();
    },

    // api to get market list
    getMarketListNetWorkCallBack() {
      this.is_market_list_loading = true; //enabled loader

      serverAddr
        .get(`/market_dashboard/exchange/detail?exchange=${this.selected_market_exchange.toLowerCase()}`, {})
        .then((response) => {
          if (response.status) {
            this.$store.commit('commitMarketList', response.data.data);
          }

          this.is_market_list_loading = false; //disabled loader
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_market_list_loading = false; //disabled loader
          }.bind(this)
        );
    },

    // api to get stocks live price list
    getStocksLivePriceNetWorkCallBack() {
      serverAddr
        .get(`/market_dashboard/live_ticker?asset=FNO&page_number=1&page_per_entries=50`, {})
        .then((response) => {
          if (response.status) {
            this.$store.commit('commitStocksLivePriceList', response.data.data);
          }
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    beforeDestroy() {
      clearInterval(this.interval);
      clearInterval(this.scroll_time_interval);
    },
  },

  computed: {
    //  returns market list
    getMarketList() {
      return this.$store.state.market_list;
    },

    // returns stocks live price list
    getStocksLivePricetList() {
      return this.$store.state.stocks_live_price_list;
    },
  },
};
</script>

<style lang="scss" scoped>
.LivePriceTicker {
  .price-container {
    position: fixed;
    width: 100%;
    z-index: 3;
    top: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .ticker-outer-section {
    background: #17002d;
    height: 25px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .market-type {
    white-space: nowrap;
    background: #250340;
    font-size: 1rem;
    color: #fff;
    font-weight: 600;
    height: 45px;
    display: flex;
    align-items: center;
    z-index: 1;
    padding: 0 10px;
  }

  .market-type:after {
    position: absolute;
    bottom: -29px;
    left: 0px;
    width: 10px;
    height: 44px;
    margin-bottom: 25px;
    content: '';
    -webkit-transform: translateY(-10%);
    transform: translateY(-10%);
    background-color: #590877;
  }

  #container {
    // width: 89%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    // overflow-x: auto;
    // overflow: hidden;
    height: 45px;
  }

  .price-list {
    display: flex;
  }

  .stock-name {
    font-size: 0.8rem;
    color: #fff;
    font-weight: 600;
  }

  .stock-price {
    font-size: 0.7rem;
    color: #daa72e;
    font-weight: 600;
    margin-left: 3px;
  }

  .percentage-change {
    font-size: 0.7rem;
    font-weight: 600;
    margin-left: 3px;
  }

  .border-right::after {
    position: absolute;
    bottom: -25px;
    right: -10px;
    width: 1px;
    height: 20px;
    margin-bottom: 20px;
    content: '';
    -webkit-transform: translateY(-10%);
    transform: translateY(-10%);
    background-color: #590877;
  }

  .stock-list-section {
    background: #17002d;
    height: 450px;
  }

  .scroll-btns {
    width: 50px;
    color: #fff;
    text-align: center;
    // margin-left: 25px;
    font-size: 1.1rem;
  }

  .stock-list-container {
    padding: 20px 30px;
    overflow-y: scroll;
    height: 400px;
  }

  .menu-links {
    position: fixed;
    top: 100px;
    display: flex;
    align-items: center;
    background-color: #17002d;
    z-index: 1;
    height: 50px;
    width: 100%;

    .menu {
      color: #fff;
      font-size: 0.8rem;
      margin-right: 20px;
      font-weight: 500;
      cursor: pointer;
      position: relative;
    }

    .active-menu-link {
      font-weight: 600;
    }

    .active-menu-link:after {
      position: absolute;
      bottom: -30px;
      left: 0;
      width: 100%;
      height: 2px;
      margin-bottom: 25px;
      content: '';
      background-color: #590877;
    }
  }

  .tag {
    height: 15px;
    line-height: 15px;
    padding: 5px 10px;
    font-size: 0.7rem;
    border: 1px solid #777777;
    color: #777777;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
  }

  .list-title {
    font-size: 0.8rem;
    color: #fff;
    font-weight: 600;
  }

  .list-items {
    font-size: 0.7rem;
    color: #fff;
    font-weight: 600;
    margin-top: 10px;
  }

  .faded-background {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 105px;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3;
    min-height: 100vh;
  }
}

::-webkit-scrollbar {
  height: 1px; /* height of horizontal scrollbar ← You're missing this */
  width: 1px; /* width of vertical scrollbar */
  //   border: 1px solid #590877;
}
.marquee {
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  width: 100%;
  position: relative;
}

.marquee-content {
  display: flex;
  animation: marquee 20s linear infinite;
  width: max-content; /* Adjust dynamically */
}

.marquee:hover .marquee-content {
  animation-play-state: paused;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
